var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filterWrapper dsio-reset-button-wrapper"},[_c('button',{staticClass:"no-button title dsio-reset-button",attrs:{"disabled":!_vm.hasFilters},on:{"click":_vm.reset}},[_c('i',{staticClass:"dsio-undo-light"})])])}
var staticRenderFns = []

export { render, staticRenderFns }